import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  filterSummary: string;
  protectedChampioned: number;
  protectedUntriaged: number;
  onConfirm: () => void;
}

/** Confirm the filter-complement cull: dismiss every paper the active
 *  filters are hiding, minus the protected classes reported here. */
export function CullOthersDialog({
  open,
  onOpenChange,
  count,
  filterSummary,
  protectedChampioned,
  protectedUntriaged,
  onConfirm,
}: Props) {
  const protectedParts: string[] = [];
  if (protectedChampioned > 0) {
    protectedParts.push(`${protectedChampioned} marked relevant`);
  }
  if (protectedUntriaged > 0) {
    protectedParts.push(
      `${protectedUntriaged} untriaged arrival${protectedUntriaged !== 1 ? "s" : ""}`,
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            Dismiss {count} hidden paper{count !== 1 ? "s" : ""}?
          </DialogTitle>
          <DialogDescription>
            Every paper hidden by the current filters ({filterSummary}) will be
            dismissed. Dismissed papers can be restored later from the
            dismissed view.
          </DialogDescription>
        </DialogHeader>
        {protectedParts.length > 0 && (
          <p className="text-xs text-muted-foreground">
            Kept: {protectedParts.join(" and ")}.
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            <Ban className="mr-2 size-4" />
            Dismiss {count}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
